export const HASH_SATISFACTION = "#satisfaction";
